import { Injectable, EventEmitter } from '@angular/core';
import { environment as env } from '../../../environments/environment';

import { from, of, Observable, BehaviorSubject, combineLatest, throwError, iif } from 'rxjs';
import { tap, map, switchMap, catchError, concatMap, shareReplay, mergeMap, first } from 'rxjs/operators';
import { faUnderline } from '@fortawesome/free-solid-svg-icons';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LgvModel } from '../../data-models/longevity.model';
import { LgvAuth0Service } from './lgv-auth0.service';
import { LgvClientAuthService } from './lgv-client-auth.service';
import { AuthProfile } from '../../data-models/auth-profile';
import { LgvLocalStorageService } from './lgv-local-storage.service';
//import { LgvSecureClientService } from './lgv-secure-client.service';

@Injectable({
    providedIn: 'root'
})
export class LgvAuthMgrService {

    _Auth0UserInfo: AuthProfile = null;
    Auth0UserInfo$ = new BehaviorSubject(this._Auth0UserInfo);

    _UserFirstName: string = null;
    UserFirstName$ = new BehaviorSubject(this._UserFirstName);

    _AuthState: string = 'None';
    AuthState$ = new BehaviorSubject(this._AuthState);

    secureClientTokenRecentlyExpried = false;

    secureClientTokenKey = 'Lgv_SecureClientToken';
    get secureClientToken(): string { return localStorage.getItem(this.secureClientTokenKey); }
    set secureClientToken(x: string) { localStorage.setItem(this.secureClientTokenKey, x); }

    secureClientExpirationKey = 'Lgv_SecureClientExpiration';
    get secureClientExpiration(): string { return localStorage.getItem(this.secureClientExpirationKey); }
    set secureClientExpiration(x: string) { localStorage.setItem(this.secureClientExpirationKey, x); }

    ClientInfo: LgvModel.ClientInfo;

    get IsAuthenticated$(): Observable<boolean> { return this.AuthState$.pipe(map(x => x !== 'None')) }
    get NotAuthenticated$(): Observable<boolean> { return this.AuthState$.pipe(map(x => x === 'None')) }
    get IsClient$(): Observable<boolean> { return this.AuthState$.pipe(map(x => x === 'ClientAuth' || x === 'SecureClientAuth')) }
    get IsClient(): boolean { return this.AuthState$.value === 'ClientAuth' || this.AuthState$.value === 'SecureClientAuth'; }
    get IsAuth0(): boolean { return this.AuthState$.value === 'Auth0Auth'; }
    get IsAuth0$(): Observable<boolean> { return this.AuthState$.pipe(map(x => x === 'Auth0Auth')) }
    get IsSecureClient(): boolean { return this.AuthState$.value === 'SecureClientAuth'; }
    get NeedsEmailVerification(): boolean { return this.IsAuth0 && this.Auth0UserInfo$.value && !this.Auth0UserInfo$.value.email_verified; }
    get IsTestingClientBearerToken(): boolean { return this.clientAuthService.IsTestingBearerToken; }
    get ClientExpiredTokenError$(): Observable<HttpErrorResponse> { return this.clientAuthService.LastError$; }
    get CurrentAuth0Tenant(): string { return this.auth0Service.origAuthSettings.name; }
    get Auth0TenantNeedsReset(): boolean { return this.auth0Service.Auth0TenantNeedsReset; }

    get HasSecureClientExpired(): boolean {
        if (!this.secureClientExpiration || !(this.secureClientExpiration.length > 0)) {
            return false;
        }

        let expDate = new Date(this.secureClientExpiration);
        let now = new Date();
        return expDate < now;
    }

    get IsSecureClient$(): Observable<boolean> {
        return this.AuthState$.pipe(
            map(m1 => {
                if (m1 === 'SecureClientAuth' && this.HasSecureClientExpired) {
                    console.log('');
                    console.log('****  Secure Client Token has Expired **** ');
                    console.log('');
                    this.secureClientTokenRecentlyExpried = true;
                    this.removeSecureClientToken();
                    this.AuthState$.next('ClientAuth');
                    return this.AuthState$.value;
                }
                else {
                    return m1;
                }
            }),
            map(x => x === 'SecureClientAuth' )
        )
    }


    OnLogOutEvent: EventEmitter<any> = new EventEmitter();

    constructor(
        private auth0Service: LgvAuth0Service,
        private clientAuthService: LgvClientAuthService,
        private lgvLocalStorageSvc: LgvLocalStorageService,
        private http: HttpClient) {

        this.auth0Service.OnAuthenticatedEvent.subscribe((isAuth) => {
            //console.log(`###### auth0Svc.OnAuthenticatedEvent() | isAuth: ${isAuth} | UseRealFinityAuthConfig : ${this.auth0Service.UseRealFinityAuthConfig}`);
            if (isAuth === true) {
                this.auth0Service.getUser$().subscribe(x => {

                    this.Auth0UserInfo$.next(x);

                    //let auth0Email = x.email as string;

                    //if (!this.auth0Service.UseRealFinityAuthConfig) {

                    //    if (this.IsClient && this.clientAuthService.ClientInfo$.value) {
                    //        let clientAuthEmail = this.clientAuthService.ClientInfo$.value.email;

                    //        if (auth0Email.toLocaleLowerCase() === clientAuthEmail.toLocaleLowerCase()) {
                    //            this.AuthState$.next('SecureClientAuth');
                    //        }
                    //        else {
                    //            console.log(`*** Invalid email used for Authentication ***`);// clientEmail: ${clientAuthEmail} | Auth0Email: ${auth0Email}   ***`);
                    //        }
                    //    }

                    //}
                    //else {
                        this.UserFirstName$.next(x.given_name);
                        this.AuthState$.next('Auth0Auth');
                        //console.log('Using RealFinity Auth0 Tenant');
                        this.clientAuthService.ClearBTOnlyFromLocalStorage();
                    //}

                });
            }
            else if (this.IsAuth0) {
                this.AuthState$.next('None');
                this.UserFirstName$.next(null);
                this.Auth0UserInfo$.next(null);
            }
        });

        this.clientAuthService.IsAuthenticated$.subscribe(isAuth => {
            if (isAuth == true) {
                this.clientAuthService.ClientInfo$.pipe(first()).subscribe(x => {
                    this.ClientInfo = x;
                    this.UserFirstName$.next(x.firstName);
                    this.AuthState$.next('ClientAuth');

                    if (this.secureClientToken && this.secureClientToken.length > 0 && !this.HasSecureClientExpired) {
                        this.setSecureClientAccessToken(this.secureClientToken);
                    }

                    if (this.auth0Service.loggedIn) {
                        this.auth0Service.logout();
                    }
                });
            }
            else if (this.IsClient) {
                this.ClientInfo = null;
                this.UserFirstName$.next(null);
                this.AuthState$.next('None');
            }
        });
    }

    //ResetTenantForAuth0() {
    //    this.auth0Service.ResetAuth0Tenant();
    //}

    Auth0Login() {
        localStorage.setItem(env.LocalStorageKeys.AuthType, env.LocalStorageKeys.RealFinityKey);

        if (this.Auth0TenantNeedsReset) {
            this.auth0Service.ResetAuth0Tenant();
        }

        this.auth0Service.login();
    }

    //SecureClientLogin() {
    //    this.auth0Service.login();
    //}

    Logout() {
        this.OnLogOutEvent.emit();

        this.clientAuthService.LastError$.next(null);

        if (this.IsSecureClient) {
            this.removeSecureClientToken();
        }
        if (this.IsClient) {
            this.clientAuthService.logout();
        }

        if (this.IsAuth0) {
            this.auth0Service.logout();
        }

    }

    CheckForSavedBearerToken() {
        this.clientAuthService.CheckForSavedBearerToken();
    }

    setSecureClientAccessToken(token: string, expiresInSeconds: number = null) {


        if (expiresInSeconds) {
            let time = new Date().getTime();
            let expDate = new Date(time + expiresInSeconds * 1000);
            this.secureClientExpiration = expDate.toString();
        }

        this.secureClientToken = token;
        this.AuthState$.next('SecureClientAuth');
    }

    removeSecureClientToken() {
        this.secureClientToken = null;
        localStorage.removeItem(this.secureClientTokenKey);
        localStorage.removeItem(this.clientAuthService.BTKey)
    }
    
}
